
<script>
export default {
  computed: {
    tutor_channel () {
      return this.$store.getters.tutor_channel
    }
  },
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getTutor_channel(to.params.id)
    })
  },
  methods: {
    getTutor_channel (id) {
      this.$store.dispatch('getTutor_channel', id)
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Tutor_channel.vue?91a62dc4